import * as Sentry from "@sentry/browser"
import * as Integrations from "@sentry/integrations"
import { Platform } from "quasar"

export default async ({ Vue, store }) => {
  Sentry.init({
		ignoreErrors: ignoreErrors,
    dsn: process.env.DSN_SENTRY,
    release: process.env.APP_VERSION,
		initialScope: scope => {
			const id = store.getters['common/id'] 
			scope.setTags(
				{ 
					idUser: id ? id : 'none',
					isCapacitor: Platform.is.capacitor,
				}
				)
			return scope
	  },
    integrations: [
      new Integrations.Vue({ Vue, attachProps: true }),
      new Integrations.RewriteFrames({
        iteratee(frame) {
          // Strip out the query part (which contains `?__WB_REVISION__=**`)
          frame.abs_path = frame.abs_path.split("?")[0]
          return frame
        },
      }),
    ],
	debug: false,
	tracesSampleRate: 1.0,
	tracingOptions: {
		trackComponents: true,
	},
	// Vue specific
	logErrors: true,
	attachProps: true,
	attachStacktrace: true,
  })
}


const ignoreErrors = [
	/{*ResizeObserver*/,
	/{*getBoundingClientRect*/,
	/{*play()*/,
	/{*CollectionReference*/,
	/{*UnhandledRejection*/,
	/{*Navigating to current location*/,
	/{*Navigation cancelled from*/,
	/{*Redirected when going from*/,
	/{*Avoided redundant navigation to current location*/,
	/{*Loading chunk*/,
	/{*isTrusted*/,
	/{*INTERNAL ASSERTION FAILED*/,
	/{*Error: Fail to load image*/,
	/{*0*/,
	/{*fullscreen error*/,
	"ResizeObserver loop limit exceeded",
	"Cannot read property 'getBoundingClientRect' of undefined",
	"Missing or insufficient permissions.",
	"undefined is not an object (evaluating 'this.$refs.scroller.getBoundingClientRect')",
	"The play() request was interrupted by a call to pause(). https://goo.gl/LdLk22",
	"No error message",
	"Unexpected token <",
	"Function CollectionReference.doc() requires its first argument to be of type non-empty string, but it was: \"\"",
	"Network Error",
	"Unexpected token '<'",
	"expected expression, got '<'",
	"The operation was aborted.",
	"\"Timeout\"",
	"Timeout",
	"Quota exceeded.",
	"Failed to fetch",
	"UnhandledRejection",
	"Non-Error promise rejection captured with keys: [object has no keys]",
	"InvalidStateError: Failed to execute 'transaction' on 'IDBDatabase': The database connection is closing.",
	"Request failed with status code 500",
	"Non-Error promise rejection captured with value: Timeout",
	"Properties can only be defined on Objects.",
	"Falha ao buscar",
	"window.zE is not a function",
	"undefined",
	"Zendesk is not defined",
	"Object doesn't support property or method 'closest'",
	"Cannot read property 'uid' of null",
	"Cannot read property 'dispose' of null"
]
